import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

export const useFormAreaName = (params = {}) => {
	const { values } = params;

	const initialValues = useMemo(() => {
		return {
			name: '',
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'name',
									label: 'Название',
								},
							},
						},
					],
				},
			],
		};
	}, []);

	const validationSchema = yup.object().shape({
		name: yup.string().required('Укажите имя'),
	});

	return { shape, initialValues, validationSchema };
};

